// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"d5affcc1","179":"5a963260","207":"7dc5ee57","330":"d93f2dbb","594":"82f87a2e"}[chunkId] + ".js";
};